import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCards = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m13.053 3.053 4.45.666c2.38.356 3.61 2.258 3.253 4.635l-.959 6.413c-.356 2.377-2.087 3.836-4.468 3.48l-4.45-.667c-2.38-.356-3.609-2.256-3.254-4.634l.96-6.414c.356-2.377 2.094-3.833 4.467-3.48"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m8.735 5.875-2.86.945c-2.29.753-3.188 2.833-2.425 5.121L5.474 18.1c.754 2.28 2.707 3.423 4.986 2.67l4.287-1.408c.717-.226 1.316-.608 1.752-1.09"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCards);
export default ForwardRef;
